import {
  get, post, update, hapus, upload, download
} from './helpers'

// API GENERAL
export function getRekomendasi($data) {
  return get(`/peserta/rekomendasi`, $data)
}

export function updateRekomendasi($data) {
  return update(`/peserta/rekomendasi`, $data)
}

export function resendRekomendasi() {
  return post(`/peserta/rekomendasi/resend`)
}